<template>
    <div>
        <v-dialog persistent v-model="display">
            <v-card>
                <v-toolbar dense color="primary" dark align="center">
                    <v-row>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Cache dispositivo</v-toolbar-title>
                        </v-col>
                        <v-col cols="6" align="right">
                            <v-btn small light @click="showCache">
                                <v-icon color="primary">mdi-autorenew</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1" align="right">
                            <v-btn small light @click="close">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container v-if="cache_data != null">
                    <v-data-table :items="cache_data" :headers="headers">
                        <!-- EVENT TYPE -->
                        <template v-slot:[`item.event_type`]="{ item }">
                            {{ getEventTypeName(item.event_type) }}
                        </template>
                        <!-- DETAIL -->
                        <template v-slot:[`item._detail`]="{ item }">
                            <v-btn small light @click="openDetail(item)">
                                <v-icon color="primary">mdi-text-search</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>        
        </v-dialog>
        <v-dialog v-model="detail_dialog.display" :retain-focus="false">
            <v-card>
                <v-toolbar dense color="primary" dark align="center">
                    <v-row>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Dettaglio evento</v-toolbar-title>
                        </v-col>
                        <v-col cols="7" align="right">
                            <v-btn small light @click="closeDetail">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container v-if="detail_dialog.items != null && detail_dialog.headers != null && detail_dialog.display">
                    <v-data-table :items="detail_dialog.items" :headers="detail_dialog.headers">
                        <!-- BOX ALARM TYPE -->
                        <template v-slot:[`item.alarm_type`]="{ item }" v-if="detail_dialog.type==0">
                            {{ getBoxAlarmTypeName(item.alarm_type) }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-card> 
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: 'VisualizzatoreCache',
    props : {
        device_id : {
            type : Number,
            required : true
        }
    },
    data(){
        return{
            detail_dialog : {
                display : false,
                headers : null,
                items : null,
                type : null
            },
            display : false,
            cache_data : null,
            headers : [
                { text: 'Tipologia evento', value: 'event_type' },
                { text: 'ID macchina', value: 'machine_id' },
                { text: 'ID interfaccia', value: 'interface_id' },
                { text: 'Data evento', value: 'event_time' },
                { text: 'Dettaglio', value: '_detail' }
            ],
            NETWORK : null
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
    },
    methods : {
        close(){
            this.cache_data = null;
            this.display = false;
        },
        closeDetail(){
            this.detail_dialog.display = false;
            this.detail_dialog.headers = null;
            this.detail_dialog.items = null;
            this.detail_dialog.type = null;
        },
        findHeader(header){
            const headers = this.detail_dialog.headers;
            const length = headers.length;
            for(let i = 0; i < length; i++){
                if(headers[i].value == header){
                    return true;
                }
            }
            return false;
        },
        getBoxAlarmTypeName(alarm_type){
            switch(alarm_type){
                case 1000:
                    return 'Box ofline';
                case 1001:
                    return 'Macchina offline';
                case 1002:
                    return 'Surriscaldamento CPU';
            }
        },
        getEventTypeName(event_type){
            return ['Allarme Box', 'Allarme Macchina', 'Dati'][event_type];
        },
        open(){
            this.showCache();
        },
        openDetail(item){
            this.detail_dialog.headers = new Array();
            this.detail_dialog.items = new Object();
            this.detail_dialog.type = item.event_type;
            switch(item.event_type){
                case 0:{
                    this.detail_dialog.headers.push({ text: 'Tipologia allarme', value: 'alarm_type' });
                    this.detail_dialog.headers.push({ text: 'ID macchina', value: 'machine_id' });
                    this.detail_dialog.headers.push({ text: 'ID Interfaccia', value: 'interface_id' });
                    this.detail_dialog.headers.push({ text: 'Data evento', value: 'event_time' });
                    this.detail_dialog.headers.push({ text: 'Stato', value: 'status' });
                    this.detail_dialog.headers.push({ text: 'Dettaglio', value: 'detail' });
                    this.detail_dialog.items[0] = item;
                }
                break;
                case 1:{
                    this.detail_dialog.headers.push({ text: 'ID macchina', value: 'machine_id' });
                    this.detail_dialog.headers.push({ text: 'Data allarme', value: 'event_time' });
                    this.detail_dialog.headers.push({ text: 'Gruppo allarme', value: 'group' });
                    this.detail_dialog.headers.push({ text: 'Codice allarme', value: 'id' });
                    this.detail_dialog.headers.push({ text: 'Stato', value: 'status' });
                    this.detail_dialog.items[0] = item;
                }
                break;
                case 2:{
                    this.detail_dialog.headers.push({ text: 'Indice colonna', value: 'index' });

                    item.data.forEach((datum) => {
                        if(this.detail_dialog.items[datum.index] == undefined){
                            this.detail_dialog.items[datum.index] = { index: datum.index };
                        }
                        if(!this.findHeader(datum.field)){
                            this.detail_dialog.headers.push({ text: datum.field, value: datum.field });
                        }
                        this.detail_dialog.items[datum.index][datum.field] = datum.value;
                    });
                }
                break;
                default: {
                    this.closeDetail();
                }
                return;
            }
            const items = new Array();            
            Object.keys(this.detail_dialog.items).forEach((key) => {
                items.push(this.detail_dialog.items[key]);
            });
            this.detail_dialog.items = items;
            this.detail_dialog.display = true;
        },
        showCache(){
            this.cache_data = null;
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { check: false },
                body: {
                    action: 'showcache',
                    token: localStorage.user_token,
                    id_dispositivo : this.device_id
                },
                method: 'PUT',
                on: {
                    load: function (response) {
                        response = JSON.parse(response);
                        const base64Decode = function(base64_string){
                            return decodeURIComponent(escape(atob(base64_string)));
                        }

                        const result = new Array();
                        response.forEach((item) => {
                            const result_item = { 
                                event_type: item.event,
                                data : new Array()
                            };
                            switch(result_item.event_type){
                                case 0:{
                                    Object.assign(result_item, item.data);
                                }
                                break;
                                case 1:{
                                    Object.assign(result_item, item.data[0]);
                                }
                                break;
                                case 2:{
                                    const keymap = [
                                        { field: 'data_acquisizione', mapped_field: 'event_time' },
                                        { field: 'id_macchina', mapped_field: 'machine_id' },
                                        { field: 'id_interfaccia', mapped_field: 'interface_id' },
                                    ]
                                    item.data.forEach((datum) => {
                                        datum.value = base64Decode(datum.value);
                                        result_item.data.push(datum);
                                        keymap.forEach((key) => {
                                            if(datum.field == key.field){
                                                result_item[key.mapped_field] = datum.value;
                                            }
                                        });
                                    });
                                }
                                break;
                                default:
                                    return;
                            }
                            result.push(result_item);
                        });
                        that.cache_data = result;
                        that.display = true;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        }
    }
}
</script>